import type { IconDefinition } from '../../types'

export default {
  details: [32, 32, [], '', 'M32.0001 4.2749H25.5545L12.9583 27.7252H19.4038L32.0001 4.2749Z M11.3738 24.782L14.4915 18.8792L6.27591 4.32227H0L11.3738 24.782Z'],
  name: 'brandVeracity',
  oldName: 'cubVeracity'
} as IconDefinition
